import { useMutation } from '@tanstack/react-query';
import { deviceApis } from '../../../../../../shared/apis/device/apis';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../../../../shared/types';
import { handleError } from '../../../../../ui/err/handleError';

export default function usePostDevice() {
  return useMutation(deviceApis.management.addModlink, {
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
